<template>
  <div>
    <v-btn color="white" class="filter-trigger" @click="dialog = true">
      <v-icon class="ma-0" color="#7D7D7D">filter_alt</v-icon>
    </v-btn>
    <v-dialog width="800" v-model="dialog" class="">
      <v-card class="pa-4 chat-history-filter">
        <h3 class="mt-3 pb-1">Filter Channels</h3>
        <v-layout row wrap>
          <v-flex xs4 v-for="channel in botChannels" :key="channel._id">
            <div
              class="d-flex align-center justify-center"
              style="height: 37px"
            >
              <v-checkbox
                class="custom-chat-checkbox"
                color="#3dd598"
                v-model="filters.channels"
                :value="channel._id"
                :id="channel._id"
              ></v-checkbox>
              <label class="custom-chat-label" :for="channel._id">
                <span>
                  <supported-platforms
                    class="supported-platforms-list"
                    :placeholder="null"
                    :manual-channels="getManualChannels(channel)"
                  />
                </span>
                {{ channel.name }}
              </label>
            </div>
          </v-flex>
        </v-layout>
        <h3 class="mt-3 pb-1">Conversation State</h3>
        <v-layout row wrap>
          <v-flex xs2>
            <v-checkbox
              color="#3dd598"
              v-model="filters.status"
              label="Active"
              :value="true"
            ></v-checkbox>
          </v-flex>
          <v-flex xs2>
            <v-checkbox
              color="#3dd598"
              v-model="filters.status"
              label="Expired"
              :value="false"
            ></v-checkbox>
          </v-flex>
        </v-layout>
        <h3 class="mt-3 pb-1">Date</h3>
        <v-layout row wrap>
          <v-flex xs6>
            <v-menu
              ref="menuFrom"
              v-model="menuFrom"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <label for="">From</label>
                <v-text-field
                  v-model="filters.date.from"
                  outline
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters.date.from"
                no-title
                @input="menuFrom = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6>
            <v-menu
              ref="menuFrom"
              v-model="menuTo"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <label for="">To</label>
                <v-text-field
                  v-model="filters.date.to"
                  outline
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters.date.to"
                no-title
                @input="menuTo = false"
                :min="filters.date.from"
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <h3 class="mt-3 pb-2">User Attributes</h3>
        <v-layout
          row
          wrap
          v-for="(item, index) in filters.attributes"
          class="delete-wrapper"
          :key="index"
        >
          <v-flex xs6>
            <v-autocomplete
              v-model="item.key"
              :items="getAttributesList(item.key)"
              outline
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-text-field outline placeholder="Value" v-model="item.value" />
          </v-flex>
          <v-btn
            fab
            small
            color=""
            class="delete-button"
            @click="deleteAttribute(index)"
            ><v-icon small color="#666">delete_outline</v-icon></v-btn
          >
        </v-layout>
        <v-btn
          large
          round
          flat
          block
          class="primary--text"
          @click="addUserAttributeFilter"
        >
          <v-icon>add_circle_outline</v-icon>
          Add Attribute
        </v-btn>
        <v-card-actions>
          <v-spacer />
          <v-btn outline @click="dialog = false"> Cancel </v-btn>
          <v-btn color="primary" @click="filterSessions">
            Filter Sessions
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import SupportedPlatforms from "../../block-build/blocks/SupportedPlatforms.vue";
export default {
  name: "filters",
  components: {
    SupportedPlatforms,
  },
  data() {
    return {
      dialog: false,
      botChannels: [],
      attributesList: [],
      attributesDynamicList: [],
      menuFrom: false,
      menuTo: false,
      filters: {
        attributes: [],
        channels: [],
        status: [],
        date: {
          from: "",
          to: "",
        },
      },
    };
  },
  async mounted() {
    await this.getChannels();
    await this.getVariables();
  },
  methods: {
    async getChannels() {
      const response = await this.$http_session_manager.get("/channels");
      this.botChannels = response.data.channels;
    },
    async getVariables() {
      const response = await this.$http_bot.get("/blocks/variables/available");

      for (let i = 0; i < response.data.length; i++) {
        if (response.data[i].variable !== "") {
          this.attributesList.push(response.data[i].variable);
        }
      }
      this.attributesDynamicList = this.attributesList;
    },
    addUserAttributeFilter() {
      this.filters.attributes.push({
        key: "",
        value: "",
      });
    },
    deleteAttribute(index) {
      this.filters.attributes.splice(index, 1);
    },
    getManualChannels(channel) {
      const arr = [];
      arr.push(channel.name.toLowerCase().replace(" ", "-"));
      return arr;
    },
    filterSessions() {
      this.dialog = false;
      this.$emit("changeFilters", this.filters);
    },
    getAttributesList(key) {
      let selectedArr = this.filters.attributes.map((item) => {
        if (key !== item.key) {
          return item.key;
        }
      });
      return _.difference(this.attributesList, selectedArr);
    },
  },
  watch: {
    filters: {
      handler() {},
      deep: true,
    },
  },
};
</script>

<style scoped></style>
